import { INIT_URL } from "App.const";
import { AppContext } from "index";
import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";

export const AppRoute = () => {
  const store = useContext(AppContext);
  if (store.init) {
    return <Outlet />;
  }

  return <Navigate to={INIT_URL} replace={true} />;
};
